document.addEventListener('DOMContentLoaded', function() {
    
    var phone = 769;

	/////////////////////////////////////////////////////////////////
	// グローバルナビ
	/////////////////////////////////////////////////////////////////
	$('#rocket-site-header .gnavi li').hover(function(){
        if($(window).width() > phone){
            $(this).find('dd').stop().slideToggle(200);
        }
	});
    
    
    /////////////////////////////////////////////////////////////////
	// ヘッダー　スマホ処理
	/////////////////////////////////////////////////////////////////
    $('#rocket-site-header .gnavi').on('click',function(){
        if($(window).width() < phone){
            if($(this).is('.add-close')){
                $(this).removeClass('add-close');
            }else{
                $(this).addClass('add-close');
            }
            $(this).children('ul').stop().slideToggle(240);
        }
    });

    $('#rocket-site-header .gnavi dt').on('click',function(e){
        if($(window).width() < phone){
            $('#rocket-site-header .gnavi dt').removeClass('add-close');
            if($(this).next('dd').is(':hidden')){
                $('#rocket-site-header .gnavi dd:visible').slideToggle(160);
            }
            if($(this).is('.add-close') | $(this).next('dd').is(':visible')){
                $(this).removeClass('add-close');
            }else{
                $(this).addClass('add-close');
            }
            
            $(this).next('dd').stop().slideToggle(160);
            return false;
        }
    });
	
	/////////////////////////////////////////////////////////////////
	// スクロール系　イベント処理
	/////////////////////////////////////////////////////////////////
	var controller =  new ScrollMagic.Controller();
    new ScrollMagic.Scene({
        triggerElement: 'body',
        offset: window.innerHeight * .6
    })
    .setClassToggle('#rocket-site-header , #rocket-site-sidebar','active').addTo(controller)

	
	/////////////////////////////////////////////////////////////////
	// モーダル系　イベント処理
	/////////////////////////////////////////////////////////////////
	$('.modal-img').modaal({type:'image'});
	$('.modal-inline').modaal();
	
	
	/////////////////////////////////////////////////////////////////
	// トップページ　ファーストビュースライダー
	/////////////////////////////////////////////////////////////////
	var fvSlider = new Swiper('#fv-slider', {
		slidesPerView: 'auto',
		loop: true,
		centeredSlides: true,
		spaceBetween: 0,
		grabCursor: true,
		speed: 800,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        autoplay: {
              delay: 6000,
              disableOnInteraction: false,
        },
	});
	
	/////////////////////////////////////////////////////////////////
	// トップページ　お客様の声 スライダー
	/////////////////////////////////////////////////////////////////
	var voiceSlide = new Swiper('#voice-slider', {
		loop: true,
		spaceBetween: 32,
		grabCursor: true,
		speed: 800,
        autoplay: {
              delay: 4000,
              disableOnInteraction: false,
        },
	});
	
	/////////////////////////////////////////////////////////////////
	// トップページ　クライアントロゴティッカー
	/////////////////////////////////////////////////////////////////
    $('#client-ticker').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        variableWidth: true,
        cssEase: 'linear',
        speed: 5000,
        slidesToShow: 5,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
    });
	
	/////////////////////////////////////////////////////////////////
	// 商品一覧　可変用
	/////////////////////////////////////////////////////////////////
	var fvSlider = new Swiper('.design-swiper', {
		slidesPerView: '3',
		loop: false,
		spaceBetween: 20,
		grabCursor: true,
		speed: 800,
		on: {
			init: function () {
				var slides = this.slides;
				if(slides.length > 3){
					var el = this.$el;
					el[0].classList.add('view');
				}
			},
		},
		breakpoints: {
			769: {
				slidesPerView: 1
			}
		}
	});

	
	/////////////////////////////////////////////////////////////////
	// 開発用のみ使用
	/////////////////////////////////////////////////////////////////
	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
	
	/////////////////////////////////////////////////////////////////
	// 共通サイドバー　料金表示部分
	/////////////////////////////////////////////////////////////////
	var tab_selector = $('.calculatebox .tabs li');
	tab_selector.on('click', function(){
		if(!$(this).is('.active')){
			var idx = $(this).attr('data-tab');
			$('.calculatebox .tabs li').removeClass('active');
			$(this).addClass('active');
			$('.calculatebox .tabitem:visible').stop().slideToggle(200, 'swing', function(){
				$('.calculatebox .tabitem').eq(idx).stop().delay(200).slideToggle(200, 'swing');
			});
		}
	});
	
	/////////////////////////////////////////////////////////////////
	// 共通サイドバー　カレンダー切り替え
	/////////////////////////////////////////////////////////////////
	var side_calender = $('.side_calender');
	side_calender.find('i').on('click',function(){
		var calender_index = $(this).attr('data-index');
		side_calender.hide(0);
		side_calender.eq(calender_index).show(0);
	});
	
    
	/////////////////////////////////////////////////////////////////
	// よくある質問　アコーディオン
	/////////////////////////////////////////////////////////////////
    $('.faqlist li dl').on('click',function(){
        if($(this).is('.active')){
            $(this).removeClass('active');
        }else{
            $(this).addClass('active');
        }
        $(this).find('dd').stop().slideToggle(200); 
    });
    
    
    /////////////////////////////////////////////////////////////////
	// テンプレート　アコーディオン
	/////////////////////////////////////////////////////////////////
    $('.tempbox .cate dt').on('click',function(){
        if($(this).is('.active')){
            $(this).removeClass('active');
        }else{
            $(this).addClass('active');
        }
        $(this).next('dd').stop().slideToggle(200); 
    });
    
	/////////////////////////////////////////////////////////////////
	// サンプル請求　アイテム選択
	/////////////////////////////////////////////////////////////////
	$('.sample-item li').on('click',function(){
		if($(this).is('.active')){
			$(this).removeClass('active');
		}else{
			if($('.sample-item li.active').length == 2){
				alert('2つまで選択してください');
			}else{
				$(this).addClass('active');
			}
		}
	});
    
    
	/////////////////////////////////////////////////////////////////
	// お届けまでの日数　タブ
	/////////////////////////////////////////////////////////////////
	$('.datacheck .tabbtn li').on('click',function(){
        $('.datacheck .tabbtn li').removeClass('active');
        $(this).addClass('active');
        var tabs = $(this).attr('data-index');
        $('.datacheck .check li:visible').hide(0,function(){
            $('.datacheck .check li').eq(tabs).show(0);
        })
	});

	
	/////////////////////////////////////////////////////////////////
	// 製品詳細ページ　下部のリストバンド画像変更
	/////////////////////////////////////////////////////////////////
	var wide_selector = $('.wide-select li');
	var order_color = $('.order-tabs li');
	var wristband_selctor = $('#wristband-toggle');
	
	wide_selector.on('click',function(){
		wide_selector.removeClass('active');
		$(this).addClass('active');
		var wide = $(this).attr('data-wide');
		wristband_selctor.attr('data-wide' , wide);
		wristband_toggle(wristband_selctor);
	});
	
	order_color.on('click', function(){
		if(!$(this).is('.active')){
			var color = $(this).attr('data-color');
			order_color.removeClass('active');
			$(this).addClass('active');
			wristband_selctor.attr('data-color' , color);
			wristband_toggle(wristband_selctor);
			order_item_toggle($(this).attr('data-tab'));
		}
	});
	
	function wristband_toggle(el){
		var path = el.attr('data-path');
		var wide = el.attr('data-wide');
		var color = el.attr('data-color');
		el.attr('src' ,   path+wide+'/'+color+'.png');
	}
	
	function order_item_toggle(idx){
        $('.order-detail .order-tab-item:visible').stop().slideToggle(200, 'swing', function(){
            $('.order-detail .order-tab-item').eq(idx).stop().delay(200).slideToggle(200, 'swing');
        });
	}
	
	/////////////////////////////////////////////////////////////////
	// 製品詳細ページ　上部の切替処理(詳細・オプションなど)
	/////////////////////////////////////////////////////////////////
	var tab_selector = $('.detail-tabs li');
	tab_selector.on('click', function(){
		if(!$(this).is('.active')){
			var idx = $(this).attr('data-tab');
			tab_selector.removeClass('active');
			$(this).addClass('active');
			$('.detail-tab-items:visible').stop().slideToggle(200, 'swing', function(){
				$('.detail-tab-items').eq(idx).stop().delay(200).slideToggle(200, 'swing');
			});
		}
	});
	

	/////////////////////////////////////////////////////////////////
	// 製品詳細ページ　下部の切替処理(単価・日数)
	/////////////////////////////////////////////////////////////////
	var toggle_item_btn = $('.toggle-item-btn .toggle-btn');
	toggle_item_btn.on('click',function(){
		var cate = $(this).attr('data-cate');
		if($(this).is('.active')){
			$(this).removeClass('active');
			toggle_small_item(cate, false , $(this));
		}else{
			$(this).addClass('active');
			toggle_small_item(cate, true , $(this));
		}
	});
	
	function toggle_small_item(cate,bool,el){
		var elem = el.parents('.order-tab-item');
		if(bool){
			elem.find('.cate'+cate).show();
		}else{
			elem.find('.cate'+cate).hide();
		}
	}

	/////////////////////////////////////////////////////////////////
	// 製品詳細ページ　オプション 色の選択(仮)
	/////////////////////////////////////////////////////////////////
	$('.select-color .selectbtns input').on('click',function(){
		var checked = $(this).val();
		$('.change-color').hide(0);
		$('.change-color').eq(checked).show(0);
        if(checked == 1){
            $("#incsection").hide(0);
        }else{
            $("#incsection").show(0);
        }
	});
	
	
	var tooltip = $('.view-tooltip');
	tooltip.hover(function(){
		var message = $(this).attr('data-txt');
		$(this).append('<div class="view-tooltip--active">'+ message +'</div>');
	},function(){
		$(this).find('.view-tooltip--active').remove();
	});
	
	/////////////////////////////////////////////////////////////////
	// 製品詳細ページ　入稿データの切り替え(仮)
	/////////////////////////////////////////////////////////////////
	$('.upload-list-btn input').on('click',function(){
		var checked = $(this).val();
		$('.upload-list li').hide(0);
		$('.upload-list li').eq(checked).show(0);
	});
	
	
	/////////////////////////////////////////////////////////////////
	// 製品詳細ページ　オプションの選択 (サンプルでも使用)
	/////////////////////////////////////////////////////////////////
	$('.option-list li').on('click', function(){
		var pare = $(this).parent();
		if(pare.is('.one')){
			pare.children().removeClass('active');
			$(this).addClass('active');
		}else{
			if($(this).is('.active')){
				$(this).removeClass('active');
			}else{
				$(this).addClass('active');
			}
		}
	});
    
	/////////////////////////////////////////////////////////////////
	// 製品テーブル部分ホバースクリプト修正
	/////////////////////////////////////////////////////////////////
    var hovtarget = $('.order-table-list .order-table tbody tr td');
	hovtarget.hover(function(){
        var cel = $(this)[0].cellIndex;
        if(cel > 0){
            if(cel % 2 == 0){
                $(this).addClass('active');
                $(this).prev('td').addClass('active');
            }else{
                $(this).addClass('active');
                $(this).next('td').addClass('active');
            }
        }
    },function(){
        hovtarget.removeClass('active');
    });
	
	/////////////////////////////////////////////////////////////////
	// フォーム系　バリデート
	/////////////////////////////////////////////////////////////////
	$('.validate .send').on('click',function(){
		var send_flag = true;
		var parent = $(this).parents('.validate');
		parent.find('.validate-alert').remove();
		for(var i = 0; i < parent.find('.require').length; i++){
			if(parent.find('.require').eq(i).val() == ''){
				send_flag = false;
				parent.find('.require').eq(i).after(alert_fomat('必須項目です'));
			}			
		}
		for(var i = 0; i < parent.find('.email').length; i++){
			if(!parent.find('.email').eq(i).val().match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)){
				send_flag = false;
				parent.find('.email').eq(i).after(alert_fomat('メールアドレスが不正です'));
			}			
		}
		for(var i = 0; i < parent.find('.tel').length; i++){
			if(!parent.find('.tel').eq(i).val().match(/^[0-9]{3}[0-9]{3}[0-9]{4}$/)){
				send_flag = false;
				parent.find('.tel').eq(i).after(alert_fomat('電話番号が不正です'));
			}			
		}
		for(var i = 0; i < parent.find('.addr').length; i++){
			if(!parent.find('.addr').eq(i).val().match(/^[0-9]{7}$/)){
				send_flag = false;
				parent.find('.addr').eq(i).after(alert_fomat('郵便番号が不正です'));
			}			
		}
		
		if(!send_flag){
			$("html, body").animate({scrollTop:parent.offset().top - $('#rocket-site-header').height()}, 400, "swing");
			return false;
		}
	});
	
	function alert_fomat(str){
		return '<div class="mt-px-1 validate-alert">'+str+'</div>'
	}
	


  /////////////////////////////////////////////////////////////////
  // ピンクシャツページ
  /////////////////////////////////////////////////////////////////
  var pinkSlides = new Swiper('#pink-slider', {
		slidesPerView: 3,
    loop: true,
    spaceBetween: 10,
    grabCursor: true,
    speed: 3000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
		breakpoints: {
			1024: {
				slidesPerView: 3
			},
			769: {
				slidesPerView: 1
			},
		}
  });

  $('#hidden-items-trg a').click( function(){
    $(this).toggleClass('active');
    $('#hidden-items-box').slideToggle(600);
  })
});

